(function () {
  'use strict';
  if (window.EFDiscovery) return;
  var markerKey = 'ef-discovery-navigation-v1';
  var ttl = 120000;
  var params = new URLSearchParams(window.location.search);
  var qa = params.get('ef_qa') === '1' || params.has('preview_theme_id') ||
    !!(window.Shopify && (window.Shopify.designMode ||
      (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main')));
  var pending = [];
  var timer = null;
  var attempts = 0;
  var context = { source: 'site_search', outcome: 'unresolved' };

  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function flush() {
    timer = null;
    if (!allowed()) { pending = []; return; }
    if (window.AhrefsAnalytics && typeof window.AhrefsAnalytics.sendEvent === 'function') {
      while (pending.length) {
        var event = pending.shift();
        try {
          var sent = window.AhrefsAnalytics.sendEvent(event.name, { props: event.props });
          if (sent && typeof sent.catch === 'function') sent.catch(function () {});
        } catch (error) { /* discovery stays functional */ }
      }
      attempts = 0;
    } else if (pending.length && attempts++ < 20) {
      timer = window.setTimeout(flush, 250);
    } else { pending = []; attempts = 0; }
  }

  function emit(stage, props) {
    if (!allowed()) return;
    var payload = Object.assign({ stage: stage, version: '1', source: context.source }, props);
    Object.keys(payload).forEach(function (key) { payload[key] = String(payload[key]); });
    pending.push({ name: qa ? 'ef_discovery_qa' : 'ef_' + stage, props: payload });
    if (pending.length > 12) pending.shift();
    if (!timer) flush();
  }

  function remember(data, destination) {
    if (!allowed()) return false;
    try {
      var url = new URL(destination, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      window.sessionStorage.setItem(markerKey, JSON.stringify(Object.assign({}, data, {
        path: url.pathname, at: Date.now(), qa: qa
      })));
      return true;
    } catch (error) { return false; }
  }

  function consume() {
    try {
      var raw = window.sessionStorage.getItem(markerKey);
      window.sessionStorage.removeItem(markerKey);
      if (!raw || !allowed()) return null;
      var value = JSON.parse(raw);
      if (!value || value.path !== window.location.pathname || Date.now() - value.at > ttl || Date.now() < value.at) return null;
      return value;
    } catch (error) { return null; }
  }

  function initializeNavigation() {
    var navigation = consume();
    if (navigation) {
      qa = qa || navigation.qa === true;
      context.source = navigation.source || context.source;
      context.outcome = navigation.outcome || context.outcome;
      if (navigation.kind === 'finder') {
        var finderProps = { outcome: context.outcome, navigation_marker_persisted: true, delivery: 'destination' };
        if (navigation.matched_products != null) finderProps.matched_products = navigation.matched_products;
        emit('finder_submit', finderProps);
      }
      if (navigation.kind === 'product' && /^\/products\/[^/]+\/?$/.test(window.location.pathname) &&
          document.body && document.body.classList.contains('template-product')) {
        emit('product_visit', { outcome: context.outcome, product_path: window.location.pathname });
      }
    }
  }
  if (window.Shopify && window.Shopify.customerPrivacy) initializeNavigation();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
      initializeNavigation();
    });
  }

  window.EFDiscovery = {
    finder: function (source, destination, count, outcome) {
      var props = { source: source, outcome: outcome, delivery: 'origin' };
      if (count != null) props.matched_products = count;
      if (destination) {
        props.navigation_marker_persisted = remember({ kind: 'finder', source: source, outcome: outcome, matched_products: count }, destination);
        // Ahrefs sendEvent uses XHR, which can be cancelled by navigation.
        // Count successful finder navigation on arrival, without delaying shoppers.
        if (props.navigation_marker_persisted) return;
      }
      emit('finder_submit', props);
    },
    search: function (outcome, nativeProducts, addedProducts) {
      context.outcome = outcome;
      emit('search_results', {
        outcome: outcome, native_product_cards_loaded: nativeProducts,
        recovered_product_cards_loaded: addedProducts,
        product_cards_loaded_on_page: nativeProducts + addedProducts
      });
    }
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.id === 'partNumberSearchForm') {
      var input = form.querySelector('#partNumber');
      if (input && input.value.trim()) window.EFDiscovery.finder('finder_part', '/search', null, 'submitted');
    } else if (form.id === 'manufacturerSearchForm') {
      var select = form.querySelector('#selectedManufacturer');
      if (select && select.value) window.EFDiscovery.finder('finder_manufacturer', select.value, null, 'submitted');
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (document.body && document.body.classList.contains('template-product')) return;
    var link = event.target && event.target.closest && event.target.closest('.ef-coll-card a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    if (!link.closest('.ef-search') && context.source.indexOf('finder_') !== 0) return;
    try {
      var destination = new URL(link.href, window.location.origin);
      if (!/^\/products\/[^/]+\/?$/.test(destination.pathname)) return;
      remember({ kind: 'product', source: context.source, outcome: context.outcome }, destination.href);
    } catch (error) { /* navigation does not depend on measurement */ }
  });
})();
